import * as yup from 'yup'

const schema = yup.object().shape({
  name: yup.string().required(),
  observation: yup.string().required(),
  origin: yup.string().required(),
  department: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required(),
  }),
  responsibleUser: yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required(),
  }),
  startDate: yup
    .date()
    .required()
    .typeError('Precisa ser uma data válida')
    .max(
      yup.ref('endDate'),
      'Data inicial não pode ser maior que a data final',
    ),
  endDate: yup
    .date()
    .required()
    .typeError('Precisa ser uma data válida')
    .min(
      yup.ref('startDate'),
      'Data final não pode ser menor que a data inicial',
    ),
})

export default schema
